import { useState } from "react"
import { auth } from "../firebase"
import { signInWithEmailAndPassword } from "firebase/auth"
import { useNavigate } from "react-router-dom"

export default function Login({ onLogin }) {
  const [loginEmail, setLoginEmail] = useState("")
  const [loginPassword, setLoginPassword] = useState("")
  const [loginStatus, setLoginStatus] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleLogin = async (event) => {
    event.preventDefault()
    setLoginStatus("")
    setIsLoading(true)

    try {
      console.log("🔐 Iniciando proceso de login...")
      const userCredential = await signInWithEmailAndPassword(auth, loginEmail, loginPassword)

      const token = await userCredential.user.getIdToken()
      const userId = userCredential.user.uid
      const userEmail = userCredential.user.email

      console.log("✅ Login exitoso:")
      console.log("- Email:", userEmail)
      console.log("- UserId:", userId)

      // Guardar datos
      document.cookie = `userId=${userId}; path=/; secure=true; samesite=strict; max-age=${60 * 60 * 24 * 7}`
      localStorage.setItem("authToken", token)
      localStorage.setItem("userEmail", userEmail)

      setLoginStatus("¡Login exitoso!")

      // Llamar callback si existe
      if (onLogin) {
        onLogin(userCredential.user)
      }

      // Redirigir después de un breve delay
      setTimeout(() => {
        navigate("/test")
      }, 1000)
    } catch (error) {
      console.error("❌ Error en login:", error)
      setLoginStatus("Credenciales incorrectas. Intenta nuevamente.")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="auth-form-container">
      <div className="auth-form-header">
        <h2>Bienvenido de vuelta</h2>
        <p>Accede a tu nube empresarial privada</p>
      </div>

      <form className="auth-form" onSubmit={handleLogin}>
        <div className="form-group">
          <label htmlFor="email">Correo Electrónico</label>
          <input
            type="email"
            id="email"
            placeholder="tu@empresa.com"
            value={loginEmail}
            onChange={(e) => setLoginEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Contraseña</label>
          <input
            type="password"
            id="password"
            placeholder="Tu contraseña"
            value={loginPassword}
            onChange={(e) => setLoginPassword(e.target.value)}
            required
          />
        </div>

        <div className="form-options">
          <label className="remember-me">
            <input type="checkbox" /> Recordarme
          </label>
          <a href="#forgot-password" className="forgot-password">
            ¿Olvidaste tu contraseña?
          </a>
        </div>

        <button type="submit" className={`auth-button ${isLoading ? "loading" : ""}`} disabled={isLoading}>
          {isLoading ? (
            <>
              <div className="button-spinner"></div>
              Iniciando sesión...
            </>
          ) : (
            "Iniciar Sesión"
          )}
        </button>
      </form>

      {loginStatus && (
        <div className={`auth-status ${loginStatus.includes("exitoso") ? "success" : "error"}`}>{loginStatus}</div>
      )}
    </div>
  )
}
